import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Palette } from 'theme';
import {
  selectBuilderResult,
  selectBuilderLoading,
  selectBuilderError,
} from 'store/chartBuilder/selectors';
import LinesTimeZoomChart from 'components/Charts/LinesTimeZoomChart';
import NewDonutChart from 'components/Charts/NewDonutChart';
import StackedBarChart from 'components/Charts/StackedBarChart';

function ChartRenderer({ result }) {
  switch (result.chartType) {
    case 'donut':
      return <NewDonutChart data={result.data} hideSliceLabels />;
    case 'stacked-bar':
      return <StackedBarChart data={result.data} />;
    case 'lines':
    case 'lines-zoom':
    default:
      return <LinesTimeZoomChart data={result.data} />;
  }
}

ChartRenderer.propTypes = {
  result: PropTypes.shape({
    chartType: PropTypes.string.isRequired,
    data: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.object]).isRequired,
  }).isRequired,
};

export default function ChartPreview() {
  const result = useSelector(selectBuilderResult);
  const loading = useSelector(selectBuilderLoading);
  const error = useSelector(selectBuilderError);

  if (loading) return <div>Loading…</div>;
  if (error) return <div style={{ color: Palette.error.main }}>{error.message}</div>;
  if (!result) return <div>Pick options and run a query.</div>;

  if (Array.isArray(result)) {
    return (
      <div>
        {result.map((r, idx) => (
          // eslint-disable-next-line react/no-array-index-key
          <ChartRenderer key={idx} result={r} />
        ))}
      </div>
    );
  }

  return <ChartRenderer result={result} />;
}
